import { Tabs } from "antd";
import type { CSSProperties } from "react";
import { useIntl } from "react-intl";
import UploadForm from "~Common/Components/UploadForm";
import type { ImageBaseTypes } from "~enums/imageBaseTypes";
import type { ImageTypes } from "~enums/imageTypes";
import styles from "./UploadImages.module.css";

export type UploadImages = {
  [key in ImageTypes]?: {
    image: { file: File | null; url: string | null };
    imageFor: ImageBaseTypes;
  };
};

type Props = {
  images: UploadImages;
  setImages: (images: (prevState: UploadImages) => UploadImages) => void;
  permissionKey: string;
};

export const UploadImages = (props: Props) => {
  const { formatMessage } = useIntl();

  const images = Object.entries(props.images).map(([imageType, value]) => {
    return {
      imageType: imageType as ImageTypes,
      ...value,
    };
  });

  return (
    <div className="card-container tabs-wrap" style={{ "--tabs-qty": images.length } as CSSProperties}>
      <Tabs
        centered
        tabBarGutter={0}
        className={styles.tabs}
        items={images.map((image) => ({
          key: image.imageType,
          label: formatMessage({ id: `add.photo.${image.imageFor}.${image.imageType}` }),
          children: (
            <UploadForm
              {...image}
              addModalMode
              className={styles.imageUpload}
              refetch={undefined}
              permissionKey={props.permissionKey}
              handleChangeFile={
                ((imageType: ImageTypes, file: { file: File | null; url: string | null }) => {
                  props.setImages((prevState) => ({
                    ...prevState,
                    [imageType]: { ...prevState[imageType], image: file },
                  }));
                }) as unknown as undefined
              }
            />
          ),
        }))}
      />
    </div>
  );
};
